import { VIZIT_ENV } from '@vizit/constants';

// Pendo will only be enabled if there is an API key in the environment variables.
// Local development should not have an API key. Check your dev-personal branch in doppler to make sure.
if (import.meta.env.VITE_PENDO_API_KEY) {
  const organizationId = localStorage.getItem('organization_id');
  const userId = localStorage.getItem('user_id');
  const organizationName = localStorage.getItem('organization_name');
  const userEmail = localStorage.getItem('user_email');

  // In order to avoid collisions in Pendo, we need to prefix the user and account IDs with the environment.
  const envUserId = userId && VIZIT_ENV !== 'prod' ? `${VIZIT_ENV}-${userId}` : userId;
  const envOrganizationId = organizationId && VIZIT_ENV !== 'prod' ? `${VIZIT_ENV}-${organizationId}` : organizationId;

  // To debug Pendo, in browser console, enter pendo.enableDebugging(). This will show you all the Pendo configuration and events.
  window.pendo?.initialize({
    visitor: {
      id: envUserId ?? 'VISITOR-UNIQUE-ID', // anonymous user id,
      email: userEmail,
    },
    ...(envOrganizationId && organizationId !== ''
      ? {
          account: {
            id: envOrganizationId,
            name: organizationName,
          },
        }
      : undefined),
    recording: {
      autoStart: true,
      enabled: true,
    },
  });
}
